import { lazy } from "react";
import Loadable from "app/components/Loadable";

const AuthConfigList = Loadable(lazy(() => import("./AuthConfigList")));
const AuthConfigAdd = Loadable(lazy(() => import("./AuthConfigAdd")));

const AuthConfigRoutes = [
  { path: "/config/auth-config", element: <AuthConfigList /> },
  { path: "/config/auth-config/:mode/:id", element: <AuthConfigAdd /> },
];

export default AuthConfigRoutes;
